import { LuMail } from "react-icons/lu"
import { appName } from "../utils/constants"

const Footer = () => {

  const email = 'support@tranfoo.com';

  return (
    <footer className="flex p-8 w-full justify-center items-center">
      <div className="flex w-full max-w-6xl items-center justify-between text-sm">
        <div className="text-gray-400">© 2025 {appName}</div>
        <div className="text-gray-400 font-light flex items-center"><LuMail className="mr-2" />{email}</div>
      </div>
    </footer>
  )
}

export default Footer